import { cssSpacing, spacing } from "../app/design-system";
import { DownloadOutlined, FileTextOutlined } from "@ant-design/icons";
import { Button, Card, Divider, Flex, Space, Typography } from "../../../../../shared/frontend/ui";
import { windowHeight } from "../../../../../shared/frontend/theme/displayZoom";
import type { ApiClient } from "../app/api/client";
import { PersonDocumentPreviewContent, type PersonDocumentPreviewRow } from "./DocumentPreviewContent";

/**
 * Anhang eines Vorgangs mit Vorschau: Titelzeile, Download und die Dokumentvorschau mit der
 * Leiste des gemeinsamen `DocumentViewer`.
 */
export function DocumentAttachmentPreviewCard({
  api,
  personId,
  doc,
  text
}: {
  api: ApiClient;
  personId: string;
  doc: PersonDocumentPreviewRow;
  text: (key: string) => string;
}) {
  return (
    <>
      <Divider style={{ margin: cssSpacing(spacing.md, 0, spacing.xs) }}>{text("Attachment")}</Divider>
      <Card
        size="small"
        title={(
          <Flex align="center" gap={8}>
            <FileTextOutlined />
            <Typography.Text ellipsis style={{ minWidth: 0 }}>
              {doc.title || doc.fileName || text("Document")}
            </Typography.Text>
          </Flex>
        )}
        extra={(
          <Space wrap>
            <Button
              icon={<DownloadOutlined />}
              onClick={() => window.open(`/api/v1/persons/${encodeURIComponent(personId)}/documents/${encodeURIComponent(doc.id)}`, "_blank", "noopener,noreferrer")}
            >
              {text("Download")}
            </Button>
          </Space>
        )}
        styles={{ body: { padding: 0, height: `min(${windowHeight("70vh")}, 720px)`, minHeight: 360, overflow: "hidden" } }}
      >
        <PersonDocumentPreviewContent
          api={api}
          personId={personId}
          doc={doc}
          text={text}
          zoomStorageKey="m1member.attachment"
        />
      </Card>
    </>
  );
}
